<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th class="text-left">Date | Day</th>
          <th class="text-center">In Time</th>
          <th class="text-center">Out Time</th>
          <th class="text-center">Status</th>
          <th class="text-center">Location</th>
          <th class="text-center">Remarks</th>
          <th class="text-center">Approval Status</th>
          <th class="text-center">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i"
            :class="getRowStatus(item.status)"
         >
          <td class="text-left">{{ item.format_calendar_date_year }} | {{ item.day }}</td>
          <td class="text-center">{{ item.in_time }}</td>
          <td class="text-center">{{ item.out_time }}</td>
          <td class="text-center">{{ item.status }}</td>
          <td class="text-center" width="20%">{{ item.attendance_locations }}</td>
          <td class="text-center">{{ item.attendance_remarks }}</td>
          <td class="text-center text-capitalize">{{ item.approval_status }}</td>
          <td class="text-center">
            <button v-if="['approved', 'pending'].includes(item.approval_status)" class="btn btn-primary btn-sm"
                    @click="openEditModal(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
    </div>

    <HrManualAttendanceModal
        v-if="store.state.isModalOpenTwo"
        :contactInfo="contactInfo"
        :formData="formData"
        @getAttendanceList="getAttendanceList"
    />
  </div>
</template>

<script setup>
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import HrManualAttendanceModal from '@/components/molecule/company/hrm-payroll/manual-attendance/HrManualAttendanceModal.vue';

const props  = defineProps({
  tableItems     : Object,
  formData:{
    type:Object,
    default:{}
  },
  getAttendanceList:{
    type:Function
  },
  contactInfo: {
    type: Object
  }
});

const {
  fetchSingleManualAttendance,
} = handleHrPayroll()
const store = useStore();
const route = useRoute();

const getRowStatus = (status) =>  {
  if (!status) return {};
  return {
    'bg-color': ['H', 'W', 'LT','L'].some(value => status.split('/').includes(value)),
    'bg-red': status === 'A',
  };
}

const openEditModal = (item) => {
  let query = `?company_id=${route.params.companyId}`;
  fetchSingleManualAttendance(item.attendance_id, query).then(res => {
    if (!res.status){
      return
    }

    let data = res.data;
    props.formData.contact_profile_id = data.contact_profile_id;
    props.formData.contact_profile_name = data.name;
    props.formData.in_time = data.in_time;
    props.formData.out_time = data.out_time;
    props.formData.is_edit = true;
    props.formData.id = data.id;
  });

  store.state.isModalOpenTwo = true
}

</script>

<style>
.bg-color{
  --bs-bg-opacity: 1;
  background-color: rgb(16 108 223 / 20%) !important;
}
.bg-red{
  --bs-bg-opacity: 1;
  background-color: rgba(223, 16, 95, 0.2) !important;
  background-color: rgb(165 45 90 / 12%) !important;
  color:red;
}
</style>
